{
  "_vgBinding": "vg-binding: CONTEXT:decisions=P17.D-25,P17.D-26,P17.D-33,P17.D-41,P17.D-42,P17.D-45,P17.D-47 INTERFACE-STANDARDS:error-shape — complete vendorRouting namespace (page shell + 4 tabs + dialogs + fence report + typed error codes keyed by error.code) owned by task-28; waves 9-11 consume t() only [task-28]",
  "nav": {
    "routing": "Routage"
  },
  "page": {
    "title": "Routage fournisseurs",
    "subtitle": "Pondérations de score, règles marchand, préférences par blueprint et rapport de la barrière géographique.",
    "placeholder": {
      "weights": "Les pondérations de score ne sont pas encore disponibles sur cet écran.",
      "merchantRules": "Les règles de routage marchand ne sont pas encore disponibles sur cet écran.",
      "preferences": "Les préférences de routage par blueprint ne sont pas encore disponibles sur cet écran.",
      "fenceReport": "Le rapport de la barrière géographique n'est pas encore disponible sur cet écran."
    }
  },
  "tabs": {
    "weights": "Pondérations",
    "merchantRules": "Règles marchand",
    "preferences": "Préférences",
    "fenceReport": "Rapport barrière"
  },
  "forbidden": {
    "title": "Accès refusé",
    "description": "L'autorisation sur les règles d'affectation est requise pour ouvrir le routage fournisseurs. Demandez-la à un administrateur.",
    "home": "Retour à l'accueil"
  },
  "common": {
    "retry": "Réessayer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "close": "Fermer",
    "loading": "Chargement…",
    "na": "N/A"
  },
  "weights": {
    "live": {
      "heading": "Pondérations actives",
      "versionLabel": "Version {{version}}",
      "configSource": {
        "document": "Issu de la configuration enregistrée",
        "fallback_default": "Issu des valeurs par défaut livrées"
      }
    },
    "fallbackDefault": "Aucune configuration enregistrée n'a été trouvée : le moteur utilise les valeurs par défaut livrées. Le routage fonctionne normalement ; proposez un jeu de pondérations pour les remplacer.",
    "axis": {
      "rating": "Note",
      "utilization": "Charge",
      "sla": "SLA",
      "cost": "Coût",
      "preferenceEpsilon": "Epsilon de préférence"
    },
    "costShadowNote": "L'axe coût est à 0 volontairement : le score est calculé et enregistré, mais il ne change aucun choix tant qu'une proposition n'augmente pas la pondération.",
    "epsilonHint": "Livré à 0 : seuls les fournisseurs à score strictement égal sont regroupés. Augmentez-le pour que des scores presque égaux partagent un groupe avant l'application des préférences.",
    "pending": {
      "heading": "Proposition en attente",
      "proposedBy": "Proposé par",
      "proposedAt": "Proposé le",
      "reason": "Motif",
      "diffLive": "Actuel",
      "diffProposed": "Proposé"
    },
    "pendingBlocksPropose": "Une proposition attend déjà une décision. Une seule peut être ouverte à la fois : approuvez-la, rejetez-la ou annulez-la d'abord.",
    "selfApprovalDisabled": "Vous avez proposé ce jeu de pondérations : un second administrateur doit l'approuver.",
    "cancelOwnerOnly": "Seul l'administrateur ayant proposé le jeu peut l'annuler.",
    "propose": {
      "heading": "Proposer un nouveau jeu",
      "sumLabel": "Total des quatre axes",
      "epsilonLabel": "Epsilon de préférence (hors total)",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Pourquoi ces pondérations doivent-elles changer ?",
      "submit": "Envoyer la proposition"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "cancel": "Annuler la proposition",
      "revert": "Restaurer ce jeu"
    },
    "revert": {
      "reasonPrefill": "Restaurer les pondérations actives avant la version {{version}}."
    },
    "approve": {
      "title": "Approuver ces pondérations ?",
      "noteLabel": "Note (facultative)",
      "confirm": "Approuver et activer"
    },
    "reject": {
      "title": "Rejeter cette proposition",
      "reasonLabel": "Motif",
      "reasonRequired": "Un motif est obligatoire : il justifie le refus dans l'historique.",
      "reasonPlaceholder": "Expliquez ce qui ne va pas dans le jeu proposé.",
      "confirm": "Rejeter la proposition"
    },
    "cancel": {
      "title": "Annuler votre proposition",
      "noteLabel": "Note (facultative)",
      "confirm": "Annuler la proposition"
    },
    "history": {
      "heading": "Historique des activations",
      "empty": "Aucun jeu n'a encore été activé. Le moteur utilise les pondérations actives affichées ci-dessus.",
      "version": "Version",
      "activatedAt": "Activé le",
      "activatedBy": "Activé par",
      "proposedBy": "Proposé par"
    },
    "toast": {
      "proposed": "Proposition envoyée. Elle attend un second administrateur.",
      "approved": "Pondérations approuvées et désormais actives.",
      "rejected": "Proposition rejetée. Les pondérations actives sont inchangées.",
      "cancelled": "Proposition annulée. Les pondérations actives sont inchangées."
    },
    "unknownAdmin": "Admin n'existe plus"
  },
  "rules": {
    "heading": "Règles de routage marchand",
    "table": {
      "merchant": "Marchand",
      "blockedCount": "Bloqués",
      "allowedCount": "Autorisés",
      "updatedAt": "Mis à jour le",
      "updatedBy": "Mis à jour par",
      "actions": "Actions"
    },
    "filters": {
      "searchLabel": "Rechercher",
      "searchPlaceholder": "Nom ou identifiant du marchand",
      "sortLabel": "Trier par"
    },
    "sort": {
      "updatedAtDesc": "Mise à jour la plus récente d'abord",
      "updatedAtAsc": "Mise à jour la plus ancienne d'abord",
      "merchantNameAsc": "Nom du marchand A→Z",
      "merchantNameDesc": "Nom du marchand Z→A"
    },
    "empty": {
      "title": "Aucun marchand n'a encore de règles",
      "description": "Cette liste ne montre que les marchands disposant déjà d'un document de règles. Rien n'est cassé : choisissez un marchand pour écrire le premier jeu."
    },
    "actions": {
      "add": "Ajouter des règles",
      "edit": "Modifier",
      "save": "Enregistrer les règles",
      "removeVendor": "Retirer le fournisseur"
    },
    "editor": {
      "title": "Règles de routage",
      "blockedLabel": "Fournisseurs bloqués",
      "allowedLabel": "Fournisseurs autorisés",
      "vendorPickerPlaceholder": "Rechercher un fournisseur à ajouter",
      "merchantPickerLabel": "Marchand"
    },
    "badge": {
      "inactive": "Inactif",
      "missing": "N'existe plus"
    },
    "semantics": {
      "blockWins": "Un fournisseur bloqué le reste, même s'il figure aussi dans la liste des autorisés.",
      "allowNarrows": "Une liste d'autorisés non vide restreint le routage à ces seuls fournisseurs ; tous les autres sont exclus.",
      "emptyPoolManual": "Si ces règles ne laissent aucun fournisseur, l'article est mis en attente d'affectation manuelle plutôt que d'atterrir ailleurs."
    },
    "conflict": {
      "heading": "Quelqu'un a enregistré avant vous",
      "body": "Vos modifications sont intactes et rien n'a encore été écrit. Choisissez de les appliquer par-dessus la version plus récente, ou de les abandonner et repartir de la version enregistrée.",
      "unreadable": "Le serveur n'a pas pu lire ses propres règles enregistrées pour ce marchand ; les listes actuelles ne sont donc pas affichées. Enregistrer écrasera ce document — vérifiez d'abord auprès de la dernière personne qui l'a modifié.",
      "retry": "Conserver mes modifications et réenregistrer",
      "discard": "Abandonner les miennes et recharger la leur",
      "changedBy": "Modifié par",
      "changedAt": "Modifié le"
    },
    "toast": {
      "saved": "Règles de routage enregistrées."
    }
  },
  "preferences": {
    "heading": "Préférences de routage par blueprint",
    "blueprintLabel": "Blueprint",
    "pickBlueprint": "Choisissez un blueprint pour voir et modifier l'ordre de ses fournisseurs.",
    "default": {
      "heading": "Valeur par défaut du blueprint"
    },
    "overrides": {
      "heading": "Surcharges par variante"
    },
    "table": {
      "rank": "Rang",
      "vendor": "Fournisseur",
      "actions": "Actions"
    },
    "actions": {
      "moveUp": "Monter",
      "moveDown": "Descendre",
      "remove": "Retirer du classement",
      "addOverride": "Ajouter une surcharge de variante",
      "removeOverride": "Supprimer cette surcharge",
      "save": "Enregistrer les préférences"
    },
    "empty": {
      "title": "Aucune préférence définie",
      "description": "Rien d'anormal : sans classement, ce blueprint route uniquement selon l'ordre des scores."
    },
    "clearedToScoreOrder": "Enregistré. Ce blueprint n'a plus de classement : le routage repasse à l'ordre des scores.",
    "limits": {
      "afterFilters": "Les préférences ne s'appliquent qu'après ces étapes : {{steps}}.",
      "topScoreGroupOnly": "Elles ne réordonnent que les fournisseurs du groupe de meilleur score — jamais un fournisseur moins bien noté au-dessus d'un mieux noté.",
      "neverAllocation": "Elles ne touchent jamais aux pourcentages d'allocation : une répartition conserve exactement la part saisie par l'administrateur."
    },
    "stage": {
      "merchant_rules": "Règles marchand",
      "location_fence": "Barrière géographique",
      "rejected": "Fournisseurs ayant refusé",
      "hard_filter": "Filtres stricts",
      "scoring": "Calcul du score"
    },
    "override": {
      "title": "Ajouter une surcharge de variante",
      "variantLabel": "Variante",
      "allTaken": "Toutes les variantes de ce blueprint ont déjà une surcharge.",
      "removeConfirm": "Supprimer la surcharge de {{variant}} ? La variante reviendra à la valeur par défaut du blueprint."
    },
    "badge": {
      "inactive": "Inactif",
      "missing": "N'existe plus",
      "variantMissing": "La variante n'existe plus"
    },
    "duplicateVendor": "Ce fournisseur figure déjà dans le classement. Chaque fournisseur ne peut apparaître qu'une fois.",
    "conflict": {
      "heading": "Quelqu'un a enregistré avant vous",
      "body": "Rien n'a été écrit : l'enregistrement est tout ou rien, donc une seule section périmée bloque l'ensemble. Vos modifications sont intactes.",
      "retry": "Conserver mes modifications et réenregistrer",
      "discard": "Abandonner les miennes et recharger la leur"
    },
    "toast": {
      "saved": "Préférences enregistrées."
    }
  },
  "fence": {
    "heading": "Rapport de la barrière géographique",
    "mode": {
      "label": "Mode de la barrière",
      "workerReported": "Rapporté par le worker de routage",
      "heartbeatAt": "Dernier signal",
      "gitSha": "Build",
      "pid": "PID du processus",
      "staleWarning": "Le worker n'a pas signalé récemment : ce mode peut être obsolète.",
      "neverReported": "Aucun worker n'a jamais signalé de mode : le mode réel est inconnu. Cet écran ne devine pas.",
      "off": "Désactivée",
      "log": "Journalisation seule",
      "enforce": "Appliquée",
      "unknown": "Inconnu"
    },
    "filters": {
      "fromLabel": "Du",
      "toLabel": "Au",
      "locationLabel": "Emplacement",
      "allLocations": "Tous les emplacements",
      "blueprintLabel": "Blueprint",
      "allBlueprints": "Tous les blueprints"
    },
    "coveredRange": {
      "label": "Période couverte",
      "truncated": "Les événements sont conservés {{ttlDays}} jours : le début de votre période a déjà expiré."
    },
    "summary": {
      "totalEvents": "Événements de barrière",
      "topScoreChanged": "Meilleur choix modifié",
      "distinctOrders": "Commandes concernées",
      "distinctVariants": "Variantes concernées",
      "distinctLocations": "Emplacements concernés",
      "topExcludedVendors": "Fournisseurs les plus exclus"
    },
    "table": {
      "heading": "Événements de barrière",
      "occurredAt": "Survenu le",
      "location": "Emplacement",
      "blueprintVariant": "Blueprint / variante",
      "order": "Commande",
      "excludedVendors": "Fournisseurs exclus",
      "poolBefore": "Pool avant",
      "poolAfter": "Pool après",
      "poolDiffHint": "Ces deux nombres indiquent combien de fournisseurs étaient éligibles, pas combien ont été choisis.",
      "topScoreChanged": "Meilleur choix modifié"
    },
    "empty": {
      "modeOff": "La barrière est désactivée : aucun événement n'est attendu ici.",
      "logNoEvents": "La barrière fonctionne et n'a rien trouvé à changer sur cette période."
    },
    "drift": {
      "heading": "Allocations hors de leur liaison",
      "explain": "Ces répartitions envoient du travail à un fournisseur que la liaison d'emplacement ne couvre pas. Rien n'est corrigé depuis cet écran : corrigez-les là où les allocations se modifient.",
      "openAllocations": "Ouvrir les allocations fournisseurs",
      "table": {
        "variant": "Variante",
        "location": "Emplacement",
        "vendor": "Fournisseur",
        "weightPct": "Part",
        "enabled": "Activé",
        "reason": "Problème"
      },
      "reason": {
        "VENDOR_NOT_IN_BINDING": "Une liaison existe à cet emplacement mais exclut ce fournisseur : corrigez l'allocation ou élargissez la liaison.",
        "NO_BINDING_FOR_LOCATION": "La variante ne lie rien à cet emplacement : créez la liaison."
      },
      "empty": "Aucune allocation ne pointe hors de sa liaison."
    },
    "ruleViolating": {
      "heading": "Affectations que les règles actuelles refuseraient",
      "explain": "Un changement de règle ne réachemine jamais un travail déjà affecté. Cette liste est informative : rien n'est déplacé automatiquement et toute correction est une décision humaine.",
      "empty": "Aucun travail en cours ne contredit une règle actuelle.",
      "assignedAt": "Affecté le",
      "ruleUpdatedAt": "Règle modifiée le",
      "table": {
        "order": "Commande",
        "merchant": "Marchand",
        "variant": "Variante",
        "vendor": "Fournisseur",
        "violation": "Motif du refus"
      },
      "violation": {
        "MERCHANT_BLOCKED": "Le marchand bloque désormais ce fournisseur.",
        "NOT_IN_ALLOWLIST": "La liste d'autorisés du marchand n'inclut plus ce fournisseur.",
        "OUTSIDE_LOCATION_BINDING": "La liaison d'emplacement ne couvre plus ce fournisseur."
      }
    },
    "priceSkew": {
      "heading": "Groupes de répartition à fort écart de coût",
      "explain": "Le moteur respecte les parts que vous avez saisies, quel qu'en soit le coût. Cette liste montre seulement où une répartition coûte cher, afin que vous décidiez de la modifier ou non.",
      "minCost": "Coût le plus bas",
      "maxCost": "Coût le plus élevé",
      "spread": "Écart",
      "costHidden": "Les montants sont masqués pour votre compte. Cette répartition est signalée car ses prix sont très éloignés.",
      "undeclaredCount": "{{count}} fournisseurs n'ont pas déclaré de coût",
      "empty": "Aucun groupe de répartition ne présente un écart de coût notable."
    },
    "enable": {
      "heading": "Comment activer la barrière",
      "alreadyEnforcing": "La barrière est déjà appliquée. Rien à changer ici."
    },
    "enableSteps": {
      "1": "Définissez {{envVar}} sur {{targetMode}} dans l'environnement des deux services.",
      "2": "Redémarrez {{first}} en premier : le worker doit appliquer la règle avant que quoi que ce soit ne l'annonce.",
      "3": "Redémarrez ensuite {{second}}.",
      "4": "Revenez à ce rapport et vérifiez que la bannière de mode affiche {{targetMode}}."
    },
    "completeness": {
      "unrepresentable": "{{count}} affectation(s) correspondent à une règle mais ne peuvent pas être affichées : créées avant l'existence des données de ce rapport, elles ne portent aucune référence de variante. Cette liste ne les couvre pas — une liste vide ici ne prouve pas l'absence d'exposition.",
      "scanLimitReached": "Seules les {{limit}} affectations ouvertes les plus récentes ont été examinées. Une règle écrite aujourd'hui expose des affectations plus anciennes, non comptées ici.",
      "truncated": "Affichage de {{returned}} sur {{matched}}. Le reste est coupé par le plafond de page, non résolu."
    }
  },
  "reasons": {
    "NO_VENDOR_MATCH": "Aucun fournisseur ne correspond à cet article : il attend une affectation manuelle.",
    "BLOCKED_BY_MERCHANT_RULE": "Les règles de routage propres au marchand n'ont laissé aucun fournisseur éligible : l'article attend une affectation manuelle.",
    "NO_VENDOR_FOR_LOCATION": "Aucun fournisseur n'est lié à cet emplacement pour cette variante : l'article attend une affectation manuelle.",
    "MERCHANT_RULES_UNAVAILABLE": "Les règles de routage du marchand n'ont pas pu être lues : l'article a été retenu au lieu d'être routé au hasard. Il s'agit d'une panne technique et non d'une règle du marchand — vérifiez le service avant de modifier la moindre règle.",
    "VENDOR_LOCATION_FROZEN": "Tous les fournisseurs de cet emplacement sont gelés par un administrateur : l'article attend une affectation manuelle. Dégelez-en un dans l'onglet Emplacements du fournisseur, ou affectez à la main."
  },
  "errors": {
    "ROUTING_WEIGHTS_SUM_INVALID": "La somme des quatre axes doit valoir 1. Ajustez-les puis renvoyez.",
    "ROUTING_WEIGHTS_PENDING_EXISTS": "Une autre proposition a pris la place en premier. La vôtre n'a pas été envoyée : traitez celle en attente, puis réessayez.",
    "ROUTING_WEIGHTS_NO_PENDING": "Il n'y a plus de proposition en attente : quelqu'un l'a traitée pendant que cette page était ouverte.",
    "ROUTING_WEIGHTS_SELF_APPROVAL": "Vous avez proposé ce jeu : vous ne pouvez pas l'approuver. Demandez à un second administrateur.",
    "ROUTING_WEIGHTS_STALE_PROPOSAL": "La proposition que vous consultiez n'est plus celle en attente. Rien n'a été décidé : lisez la proposition actuelle ci-dessous avant d'agir.",
    "ROUTING_WEIGHTS_CANCEL_FORBIDDEN": "Seul {{owner}} peut annuler cette proposition. Vous pouvez toujours l'approuver ou la rejeter.",
    "MERCHANT_ROUTING_RULE_CONFLICT": "Le même fournisseur figure à la fois dans la liste des bloqués et dans celle des autorisés. Rien n'a été enregistré : retirez-le d'un côté.",
    "MERCHANT_ROUTING_RULE_VENDOR_INVALID": "L'un de ces identifiants n'a jamais été un fournisseur. Rien n'a été enregistré : retirez-le puis réessayez.",
    "MERCHANT_ROUTING_RULE_VERSION_CONFLICT": "Quelqu'un a enregistré ces règles pendant votre saisie. Vos modifications sont conservées : choisissez comment continuer.",
    "MERCHANT_NOT_FOUND": "Ce marchand n'existe plus.",
    "ROUTING_PREFERENCE_VERSION_CONFLICT": "Quelqu'un a enregistré ces préférences pendant votre saisie. Rien n'a été écrit et vos modifications sont conservées : choisissez comment continuer.",
    "ROUTING_PREFERENCE_VENDOR_INVALID": "L'un de ces identifiants n'a jamais été un fournisseur. Rien n'a été enregistré : retirez-le puis réessayez.",
    "BLUEPRINT_NOT_FOUND": "Ce blueprint n'existe plus.",
    "ALLOCATION_VENDOR_NOT_IN_LOCATION_BINDING": "Cette répartition envoie du travail à un fournisseur que la liaison d'emplacement ne couvre pas. Rien n'a été enregistré : corrigez l'allocation ou élargissez d'abord la liaison.",
    "MERCHANT_RULES_UNAVAILABLE": "Les règles de routage du marchand n'ont pas pu être lues. Il s'agit d'une panne technique et non d'une règle : rien n'est à modifier dans les règles.",
    "VALIDATION_FAILED": "Certains champs sont invalides. Vérifiez ceux qui sont signalés puis réessayez.",
    "UNAUTHENTICATED": "Veuillez vous connecter pour continuer.",
    "FORBIDDEN": "Vous n'avez pas l'autorisation d'effectuer cette action.",
    "INTERNAL_ERROR": "Une erreur est survenue de notre côté. Veuillez réessayer.",
    "NETWORK": "Impossible de joindre le serveur — vérifiez votre connexion puis réessayez.",
    "GENERIC": "Une erreur est survenue. Veuillez réessayer."
  }
}
